(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7872],{

/***/ 52352:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(78188),
    arrayIncludes = __webpack_require__(45170),
    arrayIncludesWith = __webpack_require__(94936),
    arrayMap = __webpack_require__(75697),
    baseUnary = __webpack_require__(58792),
    cacheHas = __webpack_require__(29880);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),

/***/ 41393:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(57348);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),

/***/ 79853:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var convert = __webpack_require__(5710),
    func = convert('intersectionWith', __webpack_require__(4295));

func.placeholder = __webpack_require__(84859);
module.exports = func;


/***/ }),

/***/ 4295:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(75697),
    baseIntersection = __webpack_require__(52352),
    baseRest = __webpack_require__(5125),
    castArrayLikeObject = __webpack_require__(41393),
    last = __webpack_require__(25674);

/**
 * This method is like `_.intersection` except that it accepts `comparator`
 * which is invoked to compare elements of `arrays`. The order and references
 * of result values are determined by the first array. The comparator is
 * invoked with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.intersectionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }]
 */
var intersectionWith = baseRest(function(arrays) {
  var comparator = last(arrays),
      mapped = arrayMap(arrays, castArrayLikeObject);

  comparator = typeof comparator == 'function' ? comparator : undefined;
  if (comparator) {
    mapped.pop();
  }
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped, undefined, comparator)
    : [];
});

module.exports = intersectionWith;


/***/ }),

/***/ 69719:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/[collectionSlug]/[[...tab]]",
      function () {
        return __webpack_require__(59614);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 79438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getCityType; }
/* harmony export */ });
function getCityType(governmentType) {
    return governmentType.replace(/(\b[a-z](?!\s))/g, function(letter) {
        return letter.toUpperCase();
    });
// if (governmentType === "county") {
//   return "County";
// } else if (governmentType === "township") {
//   return "Township";
// } else {
//   return "City";
// }
};


/***/ }),

/***/ 59614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CollectionBySlug; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./src/components/navbar/NavbarLayout.tsx + 62 modules
var NavbarLayout = __webpack_require__(71858);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(94614);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(56262);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/index.ts + 23 modules
var _govlaunch_product = __webpack_require__(74047);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(16258);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(49550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(81871);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/core/networkStatus.js
var core_networkStatus = __webpack_require__(22913);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/intersectionWith.js
var intersectionWith = __webpack_require__(79853);
var intersectionWith_default = /*#__PURE__*/__webpack_require__.n(intersectionWith);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/isEqual.js
var isEqual = __webpack_require__(94741);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/omit.js
var omit = __webpack_require__(53104);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/uniqBy.js
var uniqBy = __webpack_require__(40768);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/router.js
var next_router = __webpack_require__(22051);
// EXTERNAL MODULE: ./node_modules/.pnpm/querystring@0.2.1/node_modules/querystring/index.js
var querystring = __webpack_require__(97150);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-use@17.4.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-use/esm/useToggle.js
var useToggle = __webpack_require__(35150);
// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(27068);
// EXTERNAL MODULE: ./components/seo/SeoHead.tsx
var SeoHead = __webpack_require__(35692);
;// CONCATENATED MODULE: ./components/seo/CollectionPageSeo.tsx




function CollectionPageSeo(param) {
    var collectionName = param.collectionName, tab = param.tab;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeoHead/* default */.Z, {
        title: getCollectionFormattedTitle(collectionName, tab),
        description: getCollectionFormattedDescription(collectionName, tab)
    });
};
function getCollectionFormattedTitle(collectionName, tab) {
    var intl = (0,useIntl/* default */.Z)();
    switch(tab){
        case "projects":
            return intl.formatMessage({
                defaultMessage: "{collectionName} Projects – Govlaunch Collections",
                id: "U+HNu8"
            }, {
                collectionName: collectionName
            });
        case "products":
            return intl.formatMessage({
                defaultMessage: "{collectionName} Products – Govlaunch Collections",
                id: "yZTSH0"
            }, {
                collectionName: collectionName
            });
        case "stories":
            return intl.formatMessage({
                defaultMessage: "{collectionName} Stories – Govlaunch Collections",
                id: "oa2489"
            }, {
                collectionName: collectionName
            });
        case "discussions":
            return intl.formatMessage({
                defaultMessage: "{collectionName} Discussions – Govlaunch Collections",
                id: "1AgDSY"
            }, {
                collectionName: collectionName
            });
        default:
            return intl.formatMessage({
                defaultMessage: "{collectionName} – Local Government Innovation Collections",
                id: "f0IX9R"
            }, {
                collectionName: collectionName
            });
    }
}
function getCollectionFormattedDescription(collectionName, tab) {
    var intl = (0,useIntl/* default */.Z)();
    switch(tab){
        case "projects":
            return intl.formatMessage({
                defaultMessage: "Search the {collectionName} Collection for local government innovation projects.",
                id: "PQYXpN"
            }, {
                collectionName: collectionName
            });
        case "products":
            return intl.formatMessage({
                defaultMessage: "Search the {collectionName} Collection for local government technology products.",
                id: "HdEA0C"
            }, {
                collectionName: collectionName
            });
        case "stories":
            return intl.formatMessage({
                defaultMessage: "Search the {collectionName} Collection for local government innovation stories.",
                id: "7Zblun"
            }, {
                collectionName: collectionName
            });
        default:
            return intl.formatMessage({
                defaultMessage: "Search the {collectionName} Collection on Govlaunch. Discover {collectionName} projects, products and more.",
                id: "rWiKjt"
            }, {
                collectionName: collectionName
            });
    }
}

// EXTERNAL MODULE: ./lib/mutations/ToggleBookmarkMutation.ts
var ToggleBookmarkMutation = __webpack_require__(19805);
// EXTERNAL MODULE: ./lib/utils/getCityType.ts
var getCityType = __webpack_require__(79438);
// EXTERNAL MODULE: ./lib/withIntl.tsx + 9 modules
var withIntl = __webpack_require__(21505);
// EXTERNAL MODULE: ./types/types.ts
var types = __webpack_require__(43845);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp.js
var fp = __webpack_require__(56365);
;// CONCATENATED MODULE: ./src/shared/components/MultipleFilterSelect.tsx










function MultipleFilterSelect(_param) {
    var buttonText = _param.buttonText, options = _param.options, selectedOptions = _param.selectedOptions, onChange = _param.onChange, controlledIsOpen = _param.isOpen, controlledToggleOpen = _param.onToggleOpen, props = (0,_object_without_properties/* default */.Z)(_param, [
        "buttonText",
        "options",
        "selectedOptions",
        "onChange",
        "isOpen",
        "onToggleOpen"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), uncontrolledIsOpen = ref[0], uncontrolledToggleOpen = ref[1];
    var isOpen = typeof controlledIsOpen !== "undefined" ? controlledIsOpen : uncontrolledIsOpen;
    var toggleOpen = typeof controlledToggleOpen !== "undefined" ? controlledToggleOpen : uncontrolledToggleOpen;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Popover */.J2, {
        placement: "bottom-end",
        isOpen: isOpen,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* PopoverTrigger */.xo, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    size: "sm",
                    variant: "outline",
                    bg: "white",
                    flex: 1,
                    variantColor: "gray.900",
                    rightIcon: function(props) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            width: "14",
                            height: "6",
                            viewBox: "0 0 14 6",
                            fill: "none"
                        }, props), {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M7 6L0.0717959 1.30507e-06L13.9282 9.36995e-08L7 6Z",
                                fill: "#272E38"
                            })
                        }));
                    }
                }, props), {
                    onClick: toggleOpen,
                    children: buttonText
                }))
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* PopoverArrow */.QH, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* PopoverContent */.yk, {
                maxWidth: "220px",
                zIndex: 100,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                    overflow: "hidden",
                    borderRadius: "md",
                    border: "1px",
                    borderColor: "gray.900",
                    bg: "white",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                            children: options.map(function(option) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                                    as: "label",
                                    display: "flex",
                                    alignItems: "center",
                                    pt: 2,
                                    pl: 4,
                                    pr: 4,
                                    pb: 2,
                                    _hover: {
                                        bg: "blue.100"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                            type: "checkbox",
                                            checked: selectedOptions.includes(option.value),
                                            onChange: function() {
                                                return onChange((0,fp.xor)([
                                                    option.value
                                                ], selectedOptions));
                                            }
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                            fontSize: "sm",
                                            color: "black",
                                            ml: 3,
                                            children: option.label
                                        })
                                    ]
                                }, option.value);
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                            display: "flex",
                            justifyContent: "flex-end",
                            pb: 2,
                            pr: 3,
                            pt: 2,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                                size: "xs",
                                variant: "primary",
                                minWidth: "85px",
                                onClick: toggleOpen,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Done",
                                    id: "JXdbo8"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/shared/hooks/useCountryStateFilters.ts + 1 modules
var useCountryStateFilters = __webpack_require__(29926);
;// CONCATENATED MODULE: ./src/utils/filterInUnionByTypenames.ts
function byTypename(lookingFor) {
    return function(value) {
        return lookingFor.includes(value.__typename);
    };
}
function filterInUnionByTypename(union, lookingFor) {
    return union.filter(byTypename(lookingFor));
};

// EXTERNAL MODULE: ./src/utils/nextLinkHref.ts
var nextLinkHref = __webpack_require__(88196);
// EXTERNAL MODULE: ./src/utils/stringOrFirst.ts
var stringOrFirst = __webpack_require__(39327);
// EXTERNAL MODULE: ./src/components/auth/useSignInModal.ts
var useSignInModal = __webpack_require__(51170);
// EXTERNAL MODULE: ./src/components/project/listing/ProjectCards.tsx
var ProjectCards = __webpack_require__(70455);
// EXTERNAL MODULE: ./src/components/story/pages/hidePodcastTag.ts
var hidePodcastTag = __webpack_require__(9012);
// EXTERNAL MODULE: ./src/components/story/StoryCardWithPlaceholder.tsx
var StoryCardWithPlaceholder = __webpack_require__(96432);
// EXTERNAL MODULE: ./src/components/translation/TranslationButton.tsx
var TranslationButton = __webpack_require__(98769);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
;// CONCATENATED MODULE: ./src/components/collection/graphql/fragments/CollectionGroupCardFieldsFragment.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CollectionGroupCardFields on Group {\n    _id\n    viewerIsMember\n    name\n    slug\n    logo\n    createdAt\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var CollectionGroupCardFieldsFragment = ((0,lib/* gql */.Ps)(_templateObject()));

;// CONCATENATED MODULE: ./src/components/collection/graphql/JoinGroupMutation.ts

function JoinGroupMutation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation JoinGroup($groupId: ObjectId!) {\n    joinGroup(groupId: $groupId) {\n      ... on PendingUser {\n        _id\n        primaryGroup {\n          _id\n        }\n        groups {\n          _id\n          ...CollectionGroupCardFields\n        }\n      }\n      ... on GovernmentUser {\n        _id\n        primaryGroup {\n          _id\n        }\n        groups {\n          _id\n          ...CollectionGroupCardFields\n        }\n      }\n      ... on VendorUser {\n        _id\n        primaryGroup {\n          _id\n        }\n        groups {\n          _id\n          ...CollectionGroupCardFields\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    JoinGroupMutation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var JoinGroupMutation = ((0,lib/* gql */.Ps)(JoinGroupMutation_templateObject(), CollectionGroupCardFieldsFragment));

;// CONCATENATED MODULE: ./src/components/collection/graphql/LeaveGroupMutation.ts

function LeaveGroupMutation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation LeaveGroup($groupId: ObjectId!) {\n    leaveGroup(id: $groupId) {\n      ... on PendingUser {\n        _id\n        primaryGroup {\n          _id\n        }\n        groups {\n          _id\n          ...CollectionGroupCardFields\n        }\n      }\n      ... on GovernmentUser {\n        _id\n        primaryGroup {\n          _id\n        }\n        groups {\n          _id\n          ...CollectionGroupCardFields\n        }\n      }\n      ... on VendorUser {\n        _id\n        primaryGroup {\n          _id\n        }\n        groups {\n          _id\n          ...CollectionGroupCardFields\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    LeaveGroupMutation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var LeaveGroupMutation = ((0,lib/* gql */.Ps)(LeaveGroupMutation_templateObject(), CollectionGroupCardFieldsFragment));

;// CONCATENATED MODULE: ./src/components/collection/CollectionGroupCard.tsx













var CollectionGroupCard = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var group = _param.group, props = (0,_object_without_properties/* default */.Z)(_param, [
        "group"
    ]);
    var intl = (0,useIntl/* default */.Z)();
    var _$ref = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(JoinGroupMutation, {
        variables: {
            groupId: group._id
        }
    }), 2), joinGroup = _$ref[0], loading = _$ref[1].loading;
    var _$ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(LeaveGroupMutation, {
        variables: {
            groupId: group._id
        }
    }), 1), leaveGroup = _$ref1[0];
    var router = (0,next_router.useRouter)();
    var selfie = (0,Auth/* useSelfie */.yD)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: "a",
        ref: ref,
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        px: "40px",
        borderRadius: "md",
        border: "1px",
        borderColor: "gray.100",
        bg: "white",
        minHeight: "275px"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                src: group.logo,
                name: group.name
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                fontSize: "lg",
                fontWeight: "semibold",
                mt: 5,
                mb: 6,
                textAlign: "center",
                children: group.name
            }),
            !group.viewerIsMember && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                rounded: "2xl",
                size: "sm",
                variant: "primary",
                loading: loading,
                minWidth: "72px",
                onClick: function() {
                    return joinGroup().then(function() {
                        router.push("/group?groupSlug=".concat(group.slug));
                    });
                },
                disabled: (selfie === null || selfie === void 0 ? void 0 : selfie.__typename) !== "GovernmentUser" && !((selfie === null || selfie === void 0 ? void 0 : selfie.__typename) === "PendingUser" && selfie.verified),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Join",
                    id: "P6PLpi"
                })
            }),
            group.viewerIsMember && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                position: "absolute",
                left: 2,
                bottom: 2,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Tooltip */.u, {
                    label: intl.formatMessage({
                        defaultMessage: "Leave Group",
                        id: "aN2Gli"
                    }),
                    color: "white",
                    bg: "red.600",
                    rounded: "md",
                    py: 1,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* IconButton */.hU, {
                        "aria-label": intl.formatMessage({
                            defaultMessage: "Leave Group",
                            id: "aN2Gli"
                        }),
                        icon: function() {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LeaveIcon, {});
                        },
                        onClick: function(e) {
                            e.preventDefault();
                            leaveGroup();
                        }
                    })
                })
            })
        ]
    }));
});
CollectionGroupCard.displayName = "CollectionGroupCard";
/* harmony default export */ var collection_CollectionGroupCard = (CollectionGroupCard);
function LeaveIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* SvgBox */.$C, {
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32",
        fill: "none",
        color: "gray.300",
        _hover: {
            fill: "red.600",
            color: "#fff"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                cx: "16",
                cy: "16",
                r: "15.5",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M18.6269 16L22.5674 12.0597C23.2924 11.3342 23.2924 10.1584 22.5674 9.43334C21.842 8.70744 20.6658 8.70744 19.9402 9.43334L16.0001 13.3731L12.0599 9.43334C11.3344 8.70744 10.1581 8.70744 9.43275 9.43334C8.70768 10.1584 8.70768 11.3342 9.43275 12.0597L13.3733 16L9.43275 19.9403C8.70768 20.6652 8.70768 21.8415 9.43275 22.567C10.1581 23.2925 11.3344 23.2925 12.0599 22.567L16.0001 18.6267L19.9402 22.567C20.6658 23.2925 21.842 23.2925 22.5674 22.567C23.2924 21.8415 23.2924 20.6652 22.5674 19.9403L18.6269 16Z",
                fill: "currentColor"
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/pick.js
var pick = __webpack_require__(4074);
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);
;// CONCATENATED MODULE: ./src/components/collection/CollectionTabLink.tsx









var CollectionTab = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var icon = _param.icon, label = _param.label, count = _param.count, selected = _param.selected, props = (0,_object_without_properties/* default */.Z)(_param, [
        "icon",
        "label",
        "count",
        "selected"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: "a",
        color: selected ? "blue.600" : count > 0 ? "gray.900" : "gray.500",
        display: "flex",
        flexDirection: [
            "column",
            "column",
            "row"
        ],
        alignItems: "center",
        minWidth: "135px",
        minHeight: "72px",
        borderBottom: "1px",
        borderBottomWidth: "5px",
        py: 2,
        px: [
            "8px",
            "8px",
            "24px"
        ],
        borderColor: selected ? "blue.600" : "transparent",
        ref: ref,
        _hover: {
            bg: count > 0 ? "blue.50" : undefined,
            cursor: count === 0 ? "default" : "pointer"
        }
    }, props), {
        children: [
            icon,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Text */.xv, {
                fontWeight: "semibold",
                fontSize: [
                    "md",
                    "md",
                    "lg"
                ],
                as: "span",
                ml: 2,
                whiteSpace: "nowrap",
                children: [
                    label,
                    " ",
                    count > 0 && "(".concat(count, ")")
                ]
            })
        ]
    }));
});
CollectionTab.displayName = "CollectionTab";
function CollectionTabLink(param) {
    var icon = param.icon, tab = param.tab, label = param.label, slug = param.slug, count = param.count, selected = param.selected;
    var router = (0,next_router.useRouter)();
    var dataIntercomTarget = "Collection ".concat(tab);
    if (count > 0) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: {
                pathname: "/collections/[collectionSlug]/[[...tab]]",
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    collectionSlug: slug,
                    tab: tab
                })
            },
            as: {
                pathname: "/collections/".concat(slug, "/").concat(tab),
                query: pick_default()([
                    "countries",
                    "tags"
                ], router.query)
            },
            passHref: true,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionTab, {
                icon: icon,
                label: label,
                count: count,
                selected: selected,
                "data-intercom-target": dataIntercomTarget
            })
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionTab, {
        icon: icon,
        label: label,
        count: count,
        selected: selected,
        "data-intercom-target": dataIntercomTarget
    });
};

// EXTERNAL MODULE: ./src/components/collection/getInitialTabRedirect.ts
var getInitialTabRedirect = __webpack_require__(13386);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+project@2.37.38_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/project/index.ts + 59 modules
var project = __webpack_require__(78062);
;// CONCATENATED MODULE: ./src/components/collection/graphql/CollectionBySlugQuery.ts

function CollectionBySlugQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query CollectionBySlug(\n    $slug: String!\n    $filterByItemType: CollectionItemType!\n    $cursor: String\n    $tags: [String!]!\n    $countries: [String!]!\n  ) {\n    collectionBySlug(slug: $slug) {\n      _id\n      name\n      status\n      slug\n      packaging\n      viewerDidBookmark\n      tags {\n        _id\n        name\n        slug\n        types\n      }\n      publicContentAvailable\n      sponsoring\n      sponsoringVendors {\n        _id\n        name\n        slug\n        logo\n      }\n      sponsoringProducts {\n        _id\n        name\n        slug\n        logo\n      }\n      createdAt\n      updatedAt\n      contentCounters(filterByTagSlugs: $tags, filterByCountry: $countries) {\n        projectsCount\n        groupsCount\n        productsCount\n        storiesCount\n        governmentsCount\n      }\n      content(\n        filterByItemType: $filterByItemType\n        cursor: $cursor\n        limit: 12\n        filterByTagSlugs: $tags\n        filterByCountry: $countries\n      ) {\n        items {\n          ...ProjectCardFields\n          ... on Story {\n            _id\n            title\n            slug\n            introduction\n            createdAt\n            modifiedAt\n            lastPublishedAt\n            hasPodcast\n            medias {\n              url\n              type\n            }\n            storyGovernment: government {\n              _id\n              name\n              logo\n              city {\n                _id\n                country\n              }\n            }\n            tags {\n              _id\n              slug\n              name\n            }\n          }\n          ... on Government {\n            _id\n            name\n            logo\n            slug\n            city {\n              _id\n              governmentType\n              country\n              countryName\n            }\n          }\n          ... on Product {\n            ...ProductCardFields\n          }\n          ... on Group {\n            ...CollectionGroupCardFields\n          }\n        }\n        pageInfo {\n          cursor\n          hasNextPage\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    CollectionBySlugQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




/* harmony default export */ var CollectionBySlugQuery = ((0,lib/* gql */.Ps)(CollectionBySlugQuery_templateObject(), project/* ProjectCardFieldsFragment */.SS, _govlaunch_product/* ProductCardFieldsFragment */.Bl, CollectionGroupCardFieldsFragment));

// EXTERNAL MODULE: ./src/components/collection/graphql/SelfieCollectionsQuery.ts
var SelfieCollectionsQuery = __webpack_require__(82207);
;// CONCATENATED MODULE: ./src/components/collection/graphql/TrackLastVisitOnCollectionsMutation.ts

function TrackLastVisitOnCollectionsMutation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation TrackLastVisitOnCollections($collectionIds: [ObjectId!]!) {\n    trackLastVisitOnCollections(collectionIds: $collectionIds)\n  }\n"
    ]);
    TrackLastVisitOnCollectionsMutation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var TrackLastVisitOnCollectionsMutation = ((0,lib/* gql */.Ps)(TrackLastVisitOnCollectionsMutation_templateObject()));

;// CONCATENATED MODULE: ./src/components/collection/icons.tsx


function ProjectsIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        width: "24",
        height: "21",
        viewBox: "0 0 16 22",
        fill: "none",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.64004 14.9455L5.40004 18.2555H10.6L12.36 14.9455C13.4801 14.2261 14.4008 13.2361 15.037 12.0668C15.6732 10.8975 16.0044 9.58666 16 8.25549C16 6.13376 15.1572 4.09893 13.6569 2.59864C12.1566 1.09835 10.1218 0.255493 8.00004 0.255493C5.87831 0.255493 3.84348 1.09835 2.34319 2.59864C0.842898 4.09893 4.28175e-05 6.13376 4.28175e-05 8.25549C-0.00433387 9.58666 0.326887 10.8975 0.963097 12.0668C1.59931 13.2361 2.51998 14.2261 3.64004 14.9455ZM10.85 13.5255L9.40004 16.2555H6.60004L5.15004 13.5155L4.91004 13.3755C4.02576 12.8442 3.2934 12.0939 2.78366 11.1971C2.27392 10.3002 2.00403 9.28708 2.00004 8.25549C2.00004 6.66419 2.63218 5.13807 3.7574 4.01285C4.88262 2.88763 6.40874 2.25549 8.00004 2.25549C9.59134 2.25549 11.1175 2.88763 12.2427 4.01285C13.3679 5.13807 14 6.66419 14 8.25549C13.9978 9.28878 13.7287 10.304 13.2189 11.2027C12.7091 12.1015 11.9758 12.8534 11.09 13.3855L10.85 13.5255ZM12 7.25549H9V4.25549H7V7.25549H4V9.25549H7V12.2555H9V9.25549H12V7.25549ZM11 19.2555H5V21.2555H11V19.2555Z",
            fill: "currentColor"
        })
    });
}
function StoriesIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "24",
        height: "21",
        viewBox: "0 0 24 25",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M5 5.25549V23.2555H17L23 17.2555V5.25549H5ZM17 20.4255V17.2555H20.17L17 20.4255ZM21 15.2555H15V21.2555H7V7.25549H21V15.2555Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M11 10.2555H9V12.2555H11V10.2555Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M18 10.2555H13V12.2555H18V10.2555Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M13 14.2555H9V16.2555H13V14.2555Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M1 1.25549V15.2855V17.2555H3H5V15.2855H3V3.25549H14V5.25549H16V1.25549H1Z",
                fill: "currentColor"
            })
        ]
    });
}
function DiscussionsIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        width: "24",
        height: "21",
        viewBox: "0 0 24 21",
        fill: "none",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.59 9.61559C15.424 9.79987 15.2434 9.97042 15.05 10.1256C15.025 10.1606 14.99 10.1956 14.9562 10.2293C14.9225 10.2631 14.89 10.2956 14.87 10.3256C14.3172 10.7418 13.6782 11.0288 13 11.1656C13.7831 11.2722 14.5453 11.4982 15.26 11.8356L15.38 11.8956C16.1335 12.2629 16.8251 12.7454 17.43 13.3256L17.66 13.5356C18.4482 14.3529 19.0608 15.3228 19.46 16.3856C19.8119 17.3053 19.9948 18.281 20 19.2657C20 19.5309 19.8947 19.7852 19.7071 19.9728C19.5196 20.1603 19.2652 20.2657 19 20.2657H4.9999C4.73468 20.2657 4.48033 20.1603 4.29279 19.9728C4.10525 19.7852 3.99989 19.5309 3.99989 19.2657C3.98588 18.2846 4.14847 17.3091 4.4799 16.3856C4.87915 15.3228 5.49173 14.3529 6.27991 13.5356L6.50992 13.3256C7.11484 12.7454 7.80648 12.2629 8.55993 11.8956L8.69993 11.8256C9.42776 11.4877 10.2037 11.265 11 11.1656C10.3445 11.0005 9.73342 10.6932 9.20994 10.2656L8.94994 10.1356C8.74413 9.95845 8.55347 9.76444 8.37993 9.55559C8.1511 9.27584 7.95015 8.9744 7.77993 8.65558C7.28728 7.70226 7.02041 6.64844 6.99992 5.57555V5.26555C6.99727 3.93945 7.52151 2.66662 8.45733 1.72705C9.39314 0.787488 10.6639 0.258155 11.99 0.255503C13.3161 0.252851 14.5889 0.777096 15.5285 1.71291C16.468 2.64873 16.9974 3.91945 17 5.24555V5.55555C16.9751 6.62027 16.712 7.66588 16.23 8.61558C16.0549 8.97187 15.8402 9.30732 15.59 9.61559ZM9.38994 7.26557C9.52189 7.62469 9.70731 7.96183 9.93995 8.26557C10.1903 8.57291 10.506 8.82063 10.8641 8.99076C11.2221 9.1609 11.6135 9.24917 12.01 9.24917C12.4064 9.24917 12.7978 9.1609 13.1559 8.99076C13.5139 8.82063 13.8296 8.57291 14.08 8.26557C14.7228 7.40124 15.0477 6.34163 15 5.26555C15 4.46989 14.6839 3.70682 14.1213 3.14421C13.5587 2.58159 12.7956 2.26552 12 2.26552C11.2043 2.26552 10.4412 2.58159 9.87862 3.14421C9.31601 3.70682 8.99994 4.46989 8.99994 5.26555C8.99986 5.95112 9.13229 6.63025 9.38994 7.26557ZM17.28 16.3956C17.0013 15.8615 16.6477 15.3699 16.23 14.9356V14.9256C15.9917 14.6851 15.7341 14.4644 15.46 14.2656C14.885 13.8424 14.2378 13.5273 13.55 13.3356C12.5408 13.0426 11.4691 13.0426 10.46 13.3356C9.77217 13.5273 9.12498 13.8424 8.54993 14.2656C8.27194 14.4671 8.01105 14.6912 7.76993 14.9356C7.35222 15.3699 6.99865 15.8615 6.71992 16.3956C6.67027 16.4808 6.63068 16.5709 6.59045 16.6625C6.57396 16.7001 6.55736 16.7379 6.53992 16.7757C6.32712 17.2546 6.17591 17.7586 6.08991 18.2757H17.91C17.824 17.7586 17.6728 17.2546 17.46 16.7757C17.4426 16.7379 17.426 16.7001 17.4095 16.6625C17.3692 16.5709 17.3297 16.4808 17.28 16.3956ZM0.290019 18.0957C0.38346 18.1883 0.494277 18.2617 0.616116 18.3114C0.737954 18.3612 0.868418 18.3864 1.00003 18.3857H2.54004C2.60242 17.7067 2.7365 17.0363 2.94004 16.3857H2.14004C2.30355 15.6765 2.6481 15.0219 3.14004 14.4856C3.45725 14.1639 3.82558 13.8969 4.23005 13.6956C4.531 13.2697 4.86539 12.8684 5.23006 12.4956L5.53007 12.2656C6.12511 11.6877 6.79836 11.1963 7.53008 10.8056L7.27008 10.5256C7.11008 10.3256 7.00008 10.1456 6.89008 9.96559C6.63157 10.1552 6.32063 10.26 6.00007 10.2656C5.7349 10.2545 5.47612 10.1808 5.24494 10.0504C5.01375 9.92005 4.81675 9.73677 4.67006 9.51559C4.21037 8.85725 3.97539 8.06814 4.00005 7.26557C4.00206 6.82196 4.1515 6.3916 4.42485 6.04221C4.69821 5.69282 5.07997 5.44423 5.51007 5.33555L5.50007 5.26555C5.49461 4.58727 5.59585 3.91236 5.80007 3.26553C4.77424 3.31689 3.80747 3.76089 3.10004 4.50554C2.39262 5.2502 1.99875 6.23845 2.00003 7.26557C1.9747 8.5056 2.35382 9.72016 3.08004 10.7256C3.34019 11.0732 3.65414 11.377 4.01005 11.6256C3.15495 11.9378 2.3821 12.4405 1.75003 13.0956C0.632436 14.2446 0.00495297 15.7828 1.67144e-05 17.3857C-0.000744185 17.5173 0.0244811 17.6477 0.0742461 17.7696C0.124011 17.8914 0.197337 18.0022 0.290019 18.0957ZM20.0002 11.6256C20.3501 11.397 20.6608 11.1133 20.9202 10.7856C21.6604 9.76438 22.0403 8.52618 22.0002 7.26557C22.0015 6.23845 21.6076 5.2502 20.9002 4.50554C20.1928 3.76089 19.226 3.31689 18.2002 3.26553C18.4044 3.91236 18.5056 4.58727 18.5002 5.26555V5.35555C18.9251 5.46523 19.3022 5.71165 19.5733 6.05682C19.8444 6.40198 19.9944 6.82673 20.0002 7.26557C20.0374 8.08524 19.8017 8.8941 19.3302 9.56559C19.1792 9.77866 18.9801 9.9531 18.749 10.0747C18.5179 10.1964 18.2613 10.2618 18.0002 10.2656C17.7015 10.2588 17.412 10.1611 17.1702 9.98559C16.9782 10.2687 16.7642 10.5362 16.5302 10.7856C17.2316 11.1737 17.8774 11.6547 18.4502 12.2156L18.7502 12.4956C19.1149 12.8684 19.4493 13.2697 19.7502 13.6956C20.1547 13.8969 20.523 14.1639 20.8402 14.4856C21.3322 15.0219 21.6767 15.6765 21.8402 16.3857H21.0402C21.2438 17.0363 21.3778 17.7067 21.4402 18.3857H23.0002C23.2655 18.3857 23.5198 18.2803 23.7073 18.0928C23.8949 17.9052 24.0002 17.6509 24.0002 17.3857C23.9953 15.7828 23.3678 14.2446 22.2502 13.0956C21.621 12.4418 20.8517 11.9392 20.0002 11.6256Z",
            fill: "currentColor"
        })
    });
}
function GovernmentsIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M22.714 20.412h-1.222v-9.058h1.222c.527 0 .992-.356 1.159-.885a1.335 1.335 0 00-.427-1.445L13.668 1.26a1.162 1.162 0 00-1.465 0L2.425 9.024c-.42.334-.593.917-.425 1.445.166.529.631.885 1.158.885H4.38v9.058H3.158c-.676 0-1.222.578-1.222 1.294 0 .716.546 1.294 1.222 1.294h19.556c.676 0 1.222-.578 1.222-1.294 0-.716-.546-1.294-1.222-1.294zm-9.778-16.5l6.111 4.854H6.825l6.111-4.853zm-6.111 16.5v-9.058h2.444v9.058H6.825zm4.889 0v-9.058h2.444v9.058h-2.444zm4.889 0v-9.058h2.444v9.058h-2.444z",
            fill: "currentColor"
        })
    });
}
function ProductsIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "24",
        height: "21",
        viewBox: "0 0 24 25",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M20 10.2555V20.2555H4V10.2555H20ZM22 8.25549H2V22.2555H22V8.25549Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M20 5.25549H4V7.25549H20V5.25549Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M18 2.25549H6V4.25549H18V2.25549Z",
                fill: "currentColor"
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/collection/placeholders.tsx
var placeholders = __webpack_require__(62017);
;// CONCATENATED MODULE: ./src/components/collection/pages/CollectionBySlugPage.tsx










































function CollectionBySlugPage() {
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var apolloClient = (0,useApolloClient/* useApolloClient */.x)();
    var tab = (0,stringOrFirst/* default */.Z)(router.query.tab);
    var tags = getTagsFromRouter(router);
    var countries = getCountriesFromRouter(router);
    var initialRedirected = (0,react.useRef)(false);
    var selfie = (0,Auth/* useSelfie */.yD)();
    var signInModal = (0,useSignInModal/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    var locale = (0,withIntl/* useIntlLocale */.U)().locale;
    var ref2 = (0,useQuery/* useQuery */.a)(CollectionBySlugQuery, {
        notifyOnNetworkStatusChange: true,
        variables: {
            cursor: null,
            countries: countries,
            slug: (0,stringOrFirst/* default */.Z)(router.query.collectionSlug),
            filterByItemType: getFilterFromTab(tab),
            tags: tags
        }
    }), data = ref2.data, fetchMore = ref2.fetchMore, loading = ref2.loading, networkStatus = ref2.networkStatus;
    (0,react.useEffect)(function() {
        if (data && data.collectionBySlug && data.collectionBySlug._id) {
            if (selfie) {
                apolloClient.mutate({
                    mutation: TrackLastVisitOnCollectionsMutation,
                    variables: {
                        collectionIds: [
                            data.collectionBySlug._id
                        ]
                    }
                });
            }
            var redirect = (0,getInitialTabRedirect/* default */.Z)(data.collectionBySlug.contentCounters);
            if (redirect && !initialRedirected.current && !tab) {
                router.push("/collections/[collectionSlug]/[[...tab]]", "/collections/".concat(collection.slug, "/").concat(redirect));
            }
            initialRedirected.current = true;
        }
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.collectionBySlug) === null || ref === void 0 ? void 0 : ref._id
    ]);
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ToggleBookmarkMutation/* default */.Z, {
        variables: {
            targetId: data === null || data === void 0 ? void 0 : (ref1 = data.collectionBySlug) === null || ref1 === void 0 ? void 0 : ref1._id,
            targetType: types/* IBookmarkType.Collection */.Cw.Collection
        },
        refetchQueries: [
            {
                query: SelfieCollectionsQuery/* default */.Z
            }, 
        ]
    }), 1), toggleBookmark = ref3[0];
    var countryOptions = (0,useCountryStateFilters/* default */.Z)({
        country: (0,stringOrFirst/* default */.Z)(router.query.country),
        state: ""
    }).countryOptions;
    var tabsRef = /*#__PURE__*/ (0,react.createRef)();
    (0,react.useEffect)(function() {
        if (!tabsRef.current) {
            return;
        }
        if (tab === "discussions") {
            tabsRef.current.scrollLeft = 200;
        }
        if (tab === "products") {
            tabsRef.current.scrollLeft = 999;
        }
    }, []);
    if (networkStatus === core_networkStatus/* NetworkStatus.loading */.I.loading) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
            display: "flex",
            justifyContent: "center",
            p: 6,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* LoadingSpinner */.TK, {})
        });
    }
    if (!data || !data.collectionBySlug) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* PageGridContainer */.pf, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                    mt: 8,
                    textAlign: "center",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* LoadingSpinner */.TK, {})
                })
            })
        });
    }
    var collection = data.collectionBySlug;
    var products = filterInUnionByTypename(collection.content.items.map(mapFirstTag(collection.tags)), [
        "Product"
    ]);
    var stories = filterInUnionByTypename(collection.content.items.map(mapFirstTag(collection.tags)), [
        "Story"
    ]);
    var groups = filterInUnionByTypename(collection.content.items, [
        "Group"
    ]);
    var projects = filterInUnionByTypename(collection.content.items.map(mapFirstTag(collection.tags)), [
        "GovernmentProject",
        "GroupProject",
        "VendorProject", 
    ]);
    var governments = filterInUnionByTypename(collection.content.items.map(mapFirstTag(collection.tags)), [
        "Government", 
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionPageSeo, {
                collectionName: collection.name,
                tab: tab
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                bg: "white",
                pt: 8,
                borderBottom: "1px",
                borderTop: "1px",
                borderBottomColor: "gray.100",
                borderTopColor: "gray.100",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* PageGridContainer */.pf, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                            display: [
                                "none",
                                "none",
                                "block"
                            ],
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BackToCollectionsLink, {})
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                            display: [
                                "block",
                                "block",
                                "none"
                            ],
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileCollectionFilters, {
                                router: router,
                                countryOptions: countryOptions,
                                collection: collection
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                                    display: "flex",
                                    alignItems: [
                                        "flex-start",
                                        "flex-start",
                                        "center"
                                    ],
                                    flexDirection: [
                                        "column",
                                        "column",
                                        "row"
                                    ],
                                    justifyContent: [
                                        null,
                                        null,
                                        "space-between"
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* IconButton */.hU, {
                                            display: [
                                                "inline-flex",
                                                "inline-flex",
                                                "none"
                                            ],
                                            "aria-label": collection.viewerDidBookmark ? "unbookmark collection" : "bookmark collection",
                                            "data-intercom-target": "Bookmark collection",
                                            ml: "auto",
                                            mb: 2,
                                            variant: "outline",
                                            variantColor: "teal.800",
                                            size: "sm",
                                            onClick: function() {
                                                if (selfie) {
                                                    toggleBookmark();
                                                } else {
                                                    signInModal.open();
                                                }
                                            },
                                            icon: function(props) {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                    width: "14",
                                                    height: "20",
                                                    viewBox: "0 0 14 20",
                                                    fill: "none"
                                                }, props), {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                        d: "M1 18.739L1.84784 17.9179L6.57356 13.3413L11.2992 17.9185L12.1471 18.7398V17.5594V2.62995C12.1471 1.74219 11.3984 1 10.4559 1H2.69118C1.74858 1 1 1.74152 1 2.62995V17.5587V18.739ZM6.92146 12.286L6.57361 11.9491L6.22574 12.286L2 16.3785V2.62995C2 2.31818 2.27617 2 2.69118 2H10.4559C10.8706 2 11.1471 2.31864 11.1471 2.62995V16.379L6.92146 12.286ZM6.92138 14.3743L6.57353 14.0373L6.22567 14.3742L1.58883 18.8648L1.58792 18.8657L1.58714 18.8664C1.58711 18.8665 1.58708 18.8665 1.58705 18.8665C1.40466 19.0439 1.13266 19.0953 0.897335 19.0004L0.896055 18.9999C0.659297 18.9051 0.499929 18.6784 0.5 18.4215V18.4214V2.62995C0.5 1.44861 1.48949 0.5 2.69118 0.5H10.4559C11.6577 0.5 12.6471 1.44942 12.6471 2.62995V18.4215C12.6471 18.7717 12.3568 19.0475 12.0089 19.0475H12.0085C11.8422 19.0472 11.6812 18.9836 11.5609 18.8681L11.5601 18.8673L11.5592 18.8665L6.92138 14.3743Z",
                                                        fill: collection.viewerDidBookmark ? "#28D094" : "white",
                                                        stroke: "#28D094"
                                                    })
                                                }));
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Save",
                                                id: "jvo0vs"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                                            display: "flex",
                                            alignItems: "center",
                                            width: [
                                                "100%",
                                                "100%",
                                                "auto"
                                            ],
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                                                    fontSize: "3xl",
                                                    maxWidth: "400px",
                                                    as: "h1",
                                                    children: collection.name
                                                }),
                                                collection.packaging === types/* ICollectionPackaging.Bundle */.vK.Bundle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                    ml: 4,
                                                    display: [
                                                        "none",
                                                        "none",
                                                        "inline-flex"
                                                    ],
                                                    pr: 8,
                                                    mt: 1,
                                                    mb: "auto",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MultipleFilterSelect, {
                                                        buttonText: intl.formatMessage({
                                                            defaultMessage: "Collections",
                                                            id: "ulh3kf"
                                                        }),
                                                        options: collection.tags.map(function(tag) {
                                                            return {
                                                                value: tag.slug,
                                                                label: tag.name
                                                            };
                                                        }),
                                                        selectedOptions: tags,
                                                        onChange: function(tags) {
                                                            var args = getRouterPushArgsFromSelectedValues({
                                                                tags: tags
                                                            }, router);
                                                            router.push(args.url, args.as);
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        collection.sponsoring !== types/* ICollectionSponsoring.None */.nH.None && collection.sponsoringVendors.length > 0 && collection.sponsoringProducts.length === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                            mx: [
                                                null,
                                                null,
                                                "auto"
                                            ],
                                            maxWidth: "400px",
                                            isTruncated: true,
                                            mb: [
                                                4,
                                                4,
                                                "auto"
                                            ],
                                            mt: [
                                                4,
                                                4,
                                                1
                                            ],
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                href: "/vendor?vendorSlug=".concat(collection.sponsoringVendors[0].slug),
                                                as: "/vendors/".concat(collection.sponsoringVendors[0].slug),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Anchor */.ee, {
                                                    color: "black",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "Curated by",
                                                                id: "o4hmel"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                                                            src: collection.sponsoringVendors[0].logo,
                                                            name: collection.sponsoringVendors[0].name,
                                                            size: "sm",
                                                            mx: 2
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                                            fontWeight: "bold",
                                                            fontSize: "lg",
                                                            children: collection.sponsoringVendors[0].name
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        collection.sponsoring !== types/* ICollectionSponsoring.None */.nH.None && collection.sponsoringVendors.length > 0 && collection.sponsoringProducts.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                            mx: [
                                                null,
                                                null,
                                                "auto"
                                            ],
                                            maxWidth: "400px",
                                            mb: [
                                                4,
                                                4,
                                                "auto"
                                            ],
                                            mt: [
                                                4,
                                                4,
                                                1
                                            ],
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                href: "/products/".concat(collection.sponsoringProducts[0].slug),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Anchor */.ee, {
                                                    color: "black",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                                            whiteSpace: "nowrap",
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "Curated by",
                                                                id: "o4hmel"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                                                            src: collection.sponsoringProducts[0].logo,
                                                            name: collection.sponsoringProducts[0].name,
                                                            size: "sm",
                                                            mx: 2
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                                            fontWeight: "bold",
                                                            fontSize: "lg",
                                                            clamp: 2,
                                                            children: collection.sponsoringProducts[0].name
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                            display: [
                                                "none",
                                                "none",
                                                "flex"
                                            ],
                                            mb: "auto",
                                            mt: 1,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopCollectionFilters, {
                                                router: router,
                                                countryOptions: countryOptions
                                            })
                                        })
                                    ]
                                }),
                                collection.packaging === types/* ICollectionPackaging.Bundle */.vK.Bundle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                    color: "black",
                                    fontSize: "md",
                                    fontWeight: "semibold",
                                    children: collection.tags.map(function(tag) {
                                        return tag.name;
                                    }).join(", ")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                            display: "flex",
                            overflowX: [
                                "scroll",
                                "scroll",
                                "auto"
                            ],
                            ref: tabsRef,
                            alignItems: "center",
                            bg: "white",
                            mt: 4,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionTabLink, {
                                    icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectsIcon, {}),
                                    label: intl.formatMessage({
                                        defaultMessage: "Projects",
                                        id: "UxTJRa"
                                    }),
                                    count: collection.contentCounters.projectsCount,
                                    selected: !tab || tab === "projects",
                                    tab: "projects",
                                    slug: collection.slug
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionTabLink, {
                                    icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductsIcon, {}),
                                    label: intl.formatMessage({
                                        id: "7NFfmz",
                                        defaultMessage: "Products"
                                    }),
                                    count: collection.contentCounters.productsCount,
                                    selected: tab === "products",
                                    tab: "products",
                                    slug: collection.slug
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionTabLink, {
                                    icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoriesIcon, {}),
                                    label: intl.formatMessage({
                                        defaultMessage: "Stories",
                                        id: "Ldxym4"
                                    }),
                                    count: collection.contentCounters.storiesCount,
                                    selected: tab === "stories",
                                    tab: "stories",
                                    slug: collection.slug
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionTabLink, {
                                    icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DiscussionsIcon, {}),
                                    label: intl.formatMessage({
                                        defaultMessage: "Discussions",
                                        id: "S4r/19"
                                    }),
                                    count: collection.contentCounters.groupsCount,
                                    selected: tab === "discussions",
                                    tab: "discussions",
                                    slug: collection.slug
                                }),
                                collection.tags.some(function(tag) {
                                    return tag.types.includes(types/* ITagType.Award */.mG.Award);
                                }) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionTabLink, {
                                    icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentsIcon, {}),
                                    label: intl.formatMessage({
                                        defaultMessage: "Governments",
                                        id: "qnQX9U"
                                    }),
                                    count: collection.contentCounters.governmentsCount,
                                    selected: tab === "governments",
                                    tab: "governments",
                                    slug: collection.slug
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                                    display: [
                                        "none",
                                        "none",
                                        "inline-flex"
                                    ],
                                    ml: "auto",
                                    mr: 3,
                                    variant: "outline",
                                    variantColor: "teal",
                                    size: "sm",
                                    "data-intercom-target": "Bookmark collection",
                                    onClick: function() {
                                        if (selfie) {
                                            toggleBookmark();
                                        } else {
                                            signInModal.open();
                                        }
                                    },
                                    rightIcon: function(props) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            width: "14",
                                            height: "20",
                                            viewBox: "0 0 14 20",
                                            fill: "none"
                                        }, props), {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                d: "M1 18.739L1.84784 17.9179L6.57356 13.3413L11.2992 17.9185L12.1471 18.7398V17.5594V2.62995C12.1471 1.74219 11.3984 1 10.4559 1H2.69118C1.74858 1 1 1.74152 1 2.62995V17.5587V18.739ZM6.92146 12.286L6.57361 11.9491L6.22574 12.286L2 16.3785V2.62995C2 2.31818 2.27617 2 2.69118 2H10.4559C10.8706 2 11.1471 2.31864 11.1471 2.62995V16.379L6.92146 12.286ZM6.92138 14.3743L6.57353 14.0373L6.22567 14.3742L1.58883 18.8648L1.58792 18.8657L1.58714 18.8664C1.58711 18.8665 1.58708 18.8665 1.58705 18.8665C1.40466 19.0439 1.13266 19.0953 0.897335 19.0004L0.896055 18.9999C0.659297 18.9051 0.499929 18.6784 0.5 18.4215V18.4214V2.62995C0.5 1.44861 1.48949 0.5 2.69118 0.5H10.4559C11.6577 0.5 12.6471 1.44942 12.6471 2.62995V18.4215C12.6471 18.7717 12.3568 19.0475 12.0089 19.0475H12.0085C11.8422 19.0472 11.6812 18.9836 11.5609 18.8681L11.5601 18.8673L11.5592 18.8665L6.92138 14.3743Z",
                                                fill: collection.viewerDidBookmark ? "#28D094" : "white",
                                                stroke: "#28D094"
                                            })
                                        }));
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Save",
                                        id: "jvo0vs"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* PageGridContainer */.pf, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                    mt: 8,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                        px: 2,
                        pb: "32px",
                        position: "relative",
                        children: [
                            loading && networkStatus !== core_networkStatus/* NetworkStatus.fetchMore */.I.fetchMore && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                display: "flex",
                                justifyContent: "center",
                                py: 6,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* LoadingSpinner */.TK, {})
                            }),
                            (networkStatus === core_networkStatus/* NetworkStatus.ready */.I.ready || collection.content.items.length > 0) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    (!tab || tab === "projects") && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                        children: [
                                            projects.length === 0 && !loading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(placeholders/* NoProjects */.bl, {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectCards/* default */.Z, {
                                                routeParams: {
                                                    tab: "projects"
                                                },
                                                onModalClose: function() {
                                                    var filteredCountries = querystring.stringify((0,_object_spread/* default */.Z)({}, omit_default()([
                                                        "collectionSlug",
                                                        "projectSlug",
                                                        "tab"
                                                    ], router.query)), "&");
                                                    var queryStringParameters = (filteredCountries === null || filteredCountries === void 0 ? void 0 : filteredCountries.length) > 0 ? "?".concat(filteredCountries) : "";
                                                    router.push("/collections/[collectionSlug]/[[...tab]]", "/collections/".concat(collection.slug).concat(queryStringParameters));
                                                },
                                                projects: projects,
                                                gridProps: {
                                                    columns: [
                                                        1,
                                                        2,
                                                        3
                                                    ],
                                                    spacingX: 4,
                                                    spacingY: 6
                                                }
                                            })
                                        ]
                                    }),
                                    tab === "stories" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                        children: [
                                            stories.length === 0 && !loading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(placeholders/* NoStories */.rX, {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SimpleGrid */.MI, {
                                                columns: [
                                                    1,
                                                    2,
                                                    3
                                                ],
                                                spacingX: 4,
                                                spacingY: 6,
                                                children: stories.map(function(story) {
                                                    var translationLinkWrap = function(slug) {
                                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TranslationButton/* default */.Z, {
                                                            paddingY: "4px",
                                                            onClick: function(event) {
                                                                event.preventDefault();
                                                                event.stopPropagation();
                                                                router.push("/stories/".concat(slug, "?lang=").concat(locale));
                                                            }
                                                        });
                                                    };
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                        href: "/stories/[storySlug]",
                                                        as: "/stories/".concat(story.slug),
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryCardWithPlaceholder/* default */.Z, {
                                                            story: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,hidePodcastTag/* default */.Z)(story)), {
                                                                government: story.storyGovernment
                                                            }),
                                                            translationLinkWrap: locale !== "en-US" ? translationLinkWrap : undefined
                                                        })
                                                    }, story._id);
                                                })
                                            })
                                        ]
                                    }),
                                    tab === "products" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                        children: [
                                            products.length === 0 && !loading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(placeholders/* NoProducts */.ss, {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SimpleGrid */.MI, {
                                                columns: [
                                                    1,
                                                    2,
                                                    3,
                                                    4
                                                ],
                                                spacingX: 4,
                                                spacingY: 6,
                                                children: products.map(function(product) {
                                                    var translationLinkHref = "/products/".concat(product.slug, "/").concat(locale);
                                                    var translationLinkWrap = function() {
                                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TranslationButton/* default */.Z, {
                                                            paddingY: "4px",
                                                            onClick: function(event) {
                                                                event.preventDefault();
                                                                event.stopPropagation();
                                                                router.push(translationLinkHref);
                                                            }
                                                        });
                                                    };
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                        href: "/products/".concat(product.slug),
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_product/* ProductCard */.Il, {
                                                            product: product,
                                                            translationLinkWrap: locale !== "en-US" && product.allowRequestTranslation ? translationLinkWrap : undefined
                                                        })
                                                    }, product._id);
                                                })
                                            })
                                        ]
                                    }),
                                    tab === "discussions" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                        children: [
                                            groups.length === 0 && !loading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(placeholders/* NoDiscussions */.Dk, {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SimpleGrid */.MI, {
                                                columns: [
                                                    1,
                                                    2,
                                                    3,
                                                    4
                                                ],
                                                spacingX: 4,
                                                spacingY: 6,
                                                children: groups.map(function(group) {
                                                    if (group.viewerIsMember) {
                                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                            href: "/group?groupSlug=".concat(group.slug),
                                                            as: "/groups/".concat(group.slug),
                                                            passHref: true,
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(collection_CollectionGroupCard, {
                                                                group: group
                                                            }, group._id)
                                                        });
                                                    }
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(collection_CollectionGroupCard, {
                                                        group: group
                                                    }, group._id);
                                                })
                                            })
                                        ]
                                    }),
                                    tab === "governments" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                        children: [
                                            governments.length === 0 && !loading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(placeholders/* NoGovernments */.QB, {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SimpleGrid */.MI, {
                                                columns: [
                                                    1,
                                                    2,
                                                    3,
                                                    4
                                                ],
                                                spacingX: 4,
                                                spacingY: 6,
                                                children: governments.map(function(government) {
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                        href: "/governments/[governmentSlug]/[[...content]]",
                                                        as: "/governments/".concat(government.slug),
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentWithTypeAndFlag, {
                                                            government: government
                                                        })
                                                    }, government._id);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            collection.content.pageInfo.hasNextPage && [
                                core_networkStatus/* NetworkStatus.ready */.I.ready,
                                core_networkStatus/* NetworkStatus.fetchMore */.I.fetchMore
                            ].includes(networkStatus) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                display: "flex",
                                justifyContent: "center",
                                mt: 4,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                                    variant: "secondary",
                                    loading: loading,
                                    size: "sm",
                                    rightIcon: function(props) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            width: "24",
                                            height: "12",
                                            viewBox: "0 0 24 12",
                                            fill: "none"
                                        }, props), {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                d: "M2 2.5L11.7436 9.55882L22 2.5",
                                                stroke: "currentColor",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        }));
                                    },
                                    onClick: function() {
                                        fetchMore({
                                            variables: {
                                                cursor: collection.content.pageInfo.cursor
                                            },
                                            updateQuery: function(current, param) {
                                                var fetchMoreResult = param.fetchMoreResult;
                                                if (!fetchMoreResult || !fetchMoreResult.collectionBySlug || !current.collectionBySlug) {
                                                    return {
                                                        __typename: "Query",
                                                        collectionBySlug: current.collectionBySlug
                                                    };
                                                }
                                                return {
                                                    __typename: "Query",
                                                    collectionBySlug: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, current.collectionBySlug), {
                                                        content: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fetchMoreResult.collectionBySlug.content), {
                                                            items: current.collectionBySlug.content.items.concat(fetchMoreResult.collectionBySlug.content.items)
                                                        })
                                                    })
                                                };
                                            }
                                        });
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Show more",
                                        id: "aWpBzj"
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
function getRouterPushArgsFromSelectedValues(values, router) {
    var searchParams = querystring.stringify((0,_object_spread/* default */.Z)({}, omit_default()([
        "collectionSlug",
        "tab"
    ], router.query), values), "&");
    return {
        url: (0,nextLinkHref/* appendNextLinkHrefParams */.o)(router, (0,_object_spread/* default */.Z)({}, values)),
        as: "".concat(router.basePath, "?").concat(searchParams)
    };
}
function MobileCollectionFilters(param) {
    var countryOptions = param.countryOptions, router = param.router, collection = param.collection;
    var toggleLocationSelect = function toggleLocationSelect() {
        toggleLocationSelectOpen();
        toggleTagsSelectOpen(false);
    };
    var toggleTagsSelect = function toggleTagsSelect() {
        toggleTagsSelectOpen();
        toggleLocationSelectOpen(false);
    };
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isOpen = ref[0], toggle = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isLocationSelectOpen = ref1[0], toggleLocationSelectOpen = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isTagsSelectOpen = ref2[0], toggleTagsSelectOpen = ref2[1];
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
        mb: 3,
        "data-intercom-target": "Collection filters",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                        variant: "solid",
                        bg: "blue.200",
                        size: "sm",
                        color: "gray.800",
                        leftIcon: FilterIcon,
                        onClick: toggle,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Filters",
                            id: "zSOvI0"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BackToCollectionsLink, {})
                ]
            }),
            isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                bg: "blue.100",
                py: 3,
                mx: -4,
                px: 4,
                mt: 3,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MultipleFilterSelect, {
                        buttonText: intl.formatMessage({
                            defaultMessage: "Location",
                            id: "rvirM2"
                        }),
                        width: "100%",
                        isOpen: isLocationSelectOpen,
                        onToggleOpen: toggleLocationSelect,
                        options: countryOptions,
                        selectedOptions: getCountriesFromRouter(router),
                        onChange: function(countries) {
                            var args = getRouterPushArgsFromSelectedValues({
                                countries: countries
                            }, router);
                            router.push(args.url, args.as);
                        }
                    }),
                    collection.packaging === types/* ICollectionPackaging.Bundle */.vK.Bundle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MultipleFilterSelect, {
                        isOpen: isTagsSelectOpen,
                        onToggleOpen: toggleTagsSelect,
                        buttonText: intl.formatMessage({
                            defaultMessage: "Collections",
                            id: "ulh3kf"
                        }),
                        mt: 2,
                        width: "100%",
                        options: collection.tags.map(function(tag) {
                            return {
                                value: tag.slug,
                                label: tag.name
                            };
                        }),
                        selectedOptions: getTagsFromRouter(router),
                        onChange: function(tags) {
                            var args = getRouterPushArgsFromSelectedValues({
                                tags: tags
                            }, router);
                            router.push(args.url, args.as);
                        }
                    })
                ]
            })
        ]
    });
}
function DesktopCollectionFilters(param) {
    var countryOptions = param.countryOptions, router = param.router;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
        display: "flex",
        alignItems: "center",
        "data-intercom-target": "Collection filters",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                display: "flex",
                alignItems: "center",
                mr: 4,
                color: "blue.600",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FilterIcon, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                        color: "blue.600",
                        fontSize: "md",
                        ml: 2,
                        fontWeight: "semibold",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Filters",
                            id: "zSOvI0"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MultipleFilterSelect, {
                buttonText: intl.formatMessage({
                    defaultMessage: "Location",
                    id: "rvirM2"
                }),
                options: countryOptions,
                selectedOptions: getCountriesFromRouter(router),
                onChange: function(countries) {
                    var args = getRouterPushArgsFromSelectedValues({
                        countries: countries
                    }, router);
                    router.push(args.url, args.as);
                }
            })
        ]
    });
}
function FilterIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16 5H0V3H16V5ZM13.5999 9H2.3999V7H13.5999V9ZM4.7998 13H11.1998V11H4.7998V13Z",
            fill: "currentColor"
        })
    }));
}
function BackToCollectionsLink() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: "/collections",
        passHref: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Anchor */.ee, {
            display: "flex",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                    as: "span",
                    mr: 2,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
                        width: "9",
                        height: "8",
                        viewBox: "0 0 9 8",
                        fill: "none",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M0.646447 3.64645C0.451185 3.84171 0.451184 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976312 4.7308 0.659729 4.53553 0.464467C4.34027 0.269205 4.02369 0.269204 3.82843 0.464467L0.646447 3.64645ZM2 3.5L1 3.5L1 4.5L2 4.5L2 3.5Z",
                                fill: "#086BE5"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M4.64645 3.64645C4.45118 3.84171 4.45118 4.15829 4.64645 4.35355L7.82843 7.53553C8.02369 7.7308 8.34027 7.7308 8.53553 7.53553C8.7308 7.34027 8.7308 7.02369 8.53553 6.82843L5.70711 4L8.53553 1.17157C8.7308 0.976312 8.7308 0.659729 8.53553 0.464467C8.34027 0.269205 8.02369 0.269204 7.82843 0.464467L4.64645 3.64645ZM6 3.5L5 3.5L5 4.5L6 4.5L6 3.5Z",
                                fill: "#086BE5"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Back to collections",
                        id: "vMEhBH"
                    })
                })
            ]
        })
    });
}
function getFilterFromTab(tab) {
    if (tab === "projects") {
        return types/* ICollectionItemType.Project */.sC.Project;
    }
    if (tab === "products") {
        return types/* ICollectionItemType.Product */.sC.Product;
    }
    if (tab === "stories") {
        return types/* ICollectionItemType.Story */.sC.Story;
    }
    if (tab === "discussions") {
        return types/* ICollectionItemType.Group */.sC.Group;
    }
    if (tab === "governments") {
        return types/* ICollectionItemType.Government */.sC.Government;
    }
    return types/* ICollectionItemType.Project */.sC.Project;
}
function getTagsFromRouter(router) {
    var query = router.query;
    if (!query.tags) {
        return [];
    }
    return Array.isArray(query.tags) ? query.tags : [
        query.tags
    ];
}
function getCountriesFromRouter(router) {
    var query = router.query;
    if (!query.countries) {
        return [];
    }
    return Array.isArray(query.countries) ? query.countries : [
        query.countries
    ];
}
function mapFirstTag(tags) {
    var collectionTagIds = tags.map(function(tag) {
        return tag._id;
    });
    return function(item) {
        if (item.__typename === "Group" || item.__typename === "Government") {
            return item;
        }
        var itemTagIds = item.tags.map(function(tag) {
            return tag._id;
        });
        var intersect = intersectionWith_default()((isEqual_default()), itemTagIds, collectionTagIds);
        var foundTag = item.tags.find(function(tag) {
            return tag._id === intersect[0];
        });
        var firstTag = foundTag ? [
            foundTag
        ] : [];
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
            tags: uniqBy_default()("_id", firstTag.concat(item.tags))
        });
    };
}
var GovernmentWithTypeAndFlag = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var government = _param.government, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "government"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        align: "center",
        overflow: "hidden",
        as: "a",
        ref: ref
    }, rest), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                size: "sm",
                name: government.name,
                src: government.logo
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                isTruncated: true,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                        ml: 3,
                        isTruncated: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                            fontSize: "md",
                            color: "gray.600",
                            isTruncated: true,
                            children: government.name
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                        display: "inline-flex",
                        alignItems: "center",
                        ml: 3,
                        flex: 1,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CountryFlag */.AW, {
                                width: 24,
                                height: 14,
                                countryCode: government.city.country
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Text */.xv, {
                                fontSize: "sm",
                                color: "blue.600",
                                ml: 2,
                                mb: 0,
                                children: [
                                    (0,getCityType/* default */.Z)(government.city.governmentType),
                                    " - ",
                                    government.city.countryName
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
});
GovernmentWithTypeAndFlag.displayName = "GovernmentWithTypeAndFlag";

;// CONCATENATED MODULE: ./pages/collections/[collectionSlug]/[[...tab]].tsx




function CollectionBySlug() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavbarLayout/* default */.Z, {
        navbarProps: {
            mb: 0
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionBySlugPage, {})
    });
};


/***/ }),

/***/ 13386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getInitialTabRedirect; }
/* harmony export */ });
function getInitialTabRedirect(counters) {
    if (counters.projectsCount > 0) {
        return null;
    }
    if (counters.storiesCount > 0) {
        return "stories";
    }
    if (counters.groupsCount > 0) {
        return "discussions";
    }
    if (counters.productsCount > 0) {
        return "products";
    }
    if (counters.governmentsCount > 0) {
        return "governments";
    }
    return null;
};


/***/ }),

/***/ 82207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18125);
/* harmony import */ var _src_components_collection_graphql_fragments_CollectionCardFieldsFragment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26049);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query SelfieCollections($cursor: String, $searchQuery: String, $lastVisitDate: DateTime) {\n    listAllCollections(filterByViewerBookmarkStatus: SAVED, limit: 4, cursor: $cursor, searchQuery: $searchQuery) {\n      items {\n        ...CollectionCardFields\n        newContentCounters(lastVisitAnchor: LAST_TRACKED_VIEWER_VISIT, lastVisitDate: $lastVisitDate) {\n          groupsCount\n          productsCount\n          projectsCount\n          storiesCount\n          governmentsCount\n        }\n      }\n      pageInfo {\n        cursor\n        hasNextPage\n      }\n      totalCount\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject(), _src_components_collection_graphql_fragments_CollectionCardFieldsFragment__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z));


/***/ }),

/***/ 26049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment CollectionCardFields on Collection {\n    _id\n    name\n    slug\n    packaging\n    tags {\n      _id\n      name\n    }\n    viewerDidBookmark\n    contentCounters {\n      groupsCount\n      productsCount\n      projectsCount\n      storiesCount\n      governmentsCount\n    }\n    displayOptions {\n      cardBackgroundColorHex\n      cardTitleFontColorHex\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject()));


/***/ }),

/***/ 70455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProjectCards; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_project__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78062);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19026);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54892);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22051);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59496);
/* harmony import */ var _components_project_EmptyProjectSlot__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33563);
/* harmony import */ var _src_utils_nextLinkHref__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88196);
/* harmony import */ var _src_utils_stringOrFirst__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(39327);
/* harmony import */ var _src_components_project_CreateProjectModal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23115);
/* harmony import */ var _src_components_project_modal_ProjectModal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96077);
/* harmony import */ var _src_components_project_listing_computeNavigationProps__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(36668);
/* harmony import */ var lodash_fp_noop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98483);
/* harmony import */ var lodash_fp_noop__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_noop__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67459);
/* harmony import */ var _lib_withIntl__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21505);
/* harmony import */ var _src_components_translation_TranslationButton__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98769);


















function ProjectCards(param) {
    var projects = param.projects, gridProps = param.gridProps, _onClick = param.onClick, onClick = _onClick === void 0 ? (lodash_fp_noop__WEBPACK_IMPORTED_MODULE_9___default()) : _onClick, _withAddProjectSlot = param.withAddProjectSlot, withAddProjectSlot = _withAddProjectSlot === void 0 ? false : _withAddProjectSlot, addProjectSlotText = param.addProjectSlotText, firstLocationId = param.firstLocationId, firstLocationCountry = param.firstLocationCountry, groupId = param.groupId, projectNavigationLimit = param.projectNavigationLimit, onModalClose = param.onModalClose, _routeParams = param.routeParams, routeParams = _routeParams === void 0 ? {} : _routeParams;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var isMobile = (0,_lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), showCreateProjectModal = ref[0], setShowCreateProjectModal = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), relatedProject = ref1[0], setRelatedProject = ref1[1];
    var locale = (0,_lib_withIntl__WEBPACK_IMPORTED_MODULE_11__/* .useIntlLocale */ .U)().locale;
    var projectSlugFromRouter = router.query.projectSlug;
    var langFromRouter = router.query.lang;
    var slugExistsOnProjects = projects.some(function(project) {
        return project.slug === projectSlugFromRouter;
    }) || relatedProject;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_src_components_project_CreateProjectModal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                isOpen: showCreateProjectModal,
                onClose: function() {
                    return setShowCreateProjectModal(false);
                },
                groupId: groupId
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_1__/* .PageGridContainer */ .pf, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                px: 0
            }, gridProps), {
                children: [
                    withAddProjectSlot && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_components_project_EmptyProjectSlot__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        onClick: function() {
                            return setShowCreateProjectModal(true);
                        },
                        groupId: groupId,
                        text: addProjectSlotText
                    }),
                    projects.map(function(project, index) {
                        var linkHref = isMobile ? "/projects/".concat(project.slug) : (0,_src_utils_nextLinkHref__WEBPACK_IMPORTED_MODULE_6__/* .appendNextLinkHrefParams */ .o)(router, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                            projectSlug: project.slug
                        }, routeParams));
                        var translationLinkHref = isMobile ? "/projects/[projectSlug]" : (0,_src_utils_nextLinkHref__WEBPACK_IMPORTED_MODULE_6__/* .appendNextLinkHrefParams */ .o)(router, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                            projectSlug: project.slug,
                            lang: locale
                        }, routeParams));
                        var translationLinkWrap = function() {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_src_components_translation_TranslationButton__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                paddingY: "4px",
                                onClick: function(event) {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    router.push(translationLinkHref, "/projects/".concat(project.slug, "?lang=").concat(locale));
                                }
                            });
                        };
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: linkHref,
                            as: "/projects/".concat(project.slug),
                            passHref: true,
                            scroll: false,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_govlaunch_project__WEBPACK_IMPORTED_MODULE_0__/* .ProjectCard */ .t, {
                                "data-intercom-target": index === 0 ? "First project" : undefined,
                                project: project,
                                onClick: function(event) {
                                    return onClick(event, project, index);
                                },
                                firstLocationId: firstLocationId,
                                firstLocationCountry: firstLocationCountry,
                                translationLinkWrap: locale !== "en-US" ? translationLinkWrap : undefined
                            })
                        }, project._id);
                    })
                ]
            })),
            projectSlugFromRouter && slugExistsOnProjects && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_src_components_project_modal_ProjectModal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                onClickProject: function(project) {
                    setRelatedProject(project);
                },
                projectSlug: (0,_src_utils_stringOrFirst__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(projectSlugFromRouter),
                navigation: (0,_src_components_project_listing_computeNavigationProps__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(projects.slice(0, projectNavigationLimit), (0,_src_utils_stringOrFirst__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(projectSlugFromRouter)),
                onClose: onModalClose,
                lang: (0,_src_utils_stringOrFirst__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(langFromRouter)
            })
        ]
    });
};


/***/ }),

/***/ 96432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_story__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7909);





var StoryCardWithPlaceholder = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(_param, ref) {
    var story = _param.story, translationLinkWrap = _param.translationLinkWrap, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "story",
        "translationLinkWrap"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_govlaunch_story__WEBPACK_IMPORTED_MODULE_1__/* .StoryCard */ .Ey, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        story: story,
        placeholderImageSrc: "/static/story/story-card-placeholder.png",
        ref: ref,
        translationLinkWrap: translationLinkWrap
    }, props));
});
StoryCardWithPlaceholder.displayName = "StoryCardWithPlaceholder";
/* harmony default export */ __webpack_exports__["Z"] = (StoryCardWithPlaceholder);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3481,5522,2727,7909,4047,9932,504,5017,9926,3966,9774,2888,179], function() { return __webpack_exec__(69719); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);